/* eslint-disable import/no-default-export */
import Cookies from 'js-cookie';
import React from 'react';

interface LogoutTriggerProps {
  returnUrl?: string;
}

class LogoutTrigger extends React.Component<LogoutTriggerProps> {
  formRef: React.RefObject<HTMLFormElement>;
  constructor(props: LogoutTriggerProps) {
    super(props);
    this.formRef = React.createRef<HTMLFormElement>();
  }

  componentDidMount() {
    const current = this.formRef.current;
    if (current) {
      current.submit();
    }
  }

  render() {
    const { returnUrl } = this.props;

    return (
      <form
        method="post"
        action="/logout"
        style={{ display: 'none' }}
        ref={this.formRef}
      >
        <input name="dsc" defaultValue={Cookies.get('dsc')} />
        {returnUrl && <input name="returnUrl" defaultValue={returnUrl} />}
      </form>
    );
  }
}
export default LogoutTrigger;



// WEBPACK FOOTER //
// ./app/gamma/src/components/logout-trigger/logout-trigger.tsx